function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { AlertWrapper } from '../styled.js';
import { Position, ALERT_PORTAL_ID, getClassByPosition, getWrapperBlockStyles } from '../utils.js';
import { jsx } from '@emotion/react/jsx-runtime';

var AlertPortal = function AlertPortal(_ref) {
  var children = _ref.children,
      _ref$position = _ref.position,
      portalPosition = _ref$position === void 0 ? Position.BottomRight : _ref$position,
      shouldUsePortal = _ref.shouldUsePortal;

  var _useState = useState(document.getElementById(ALERT_PORTAL_ID)),
      _useState2 = _slicedToArray(_useState, 2),
      alertPortal = _useState2[0],
      setAlertPortal = _useState2[1];

  useEffect(function () {
    if (!document) return;

    if (!alertPortal) {
      var alertPortalElement = document.createElement('div');
      alertPortalElement.setAttribute('id', ALERT_PORTAL_ID);
      Object.values(Position).forEach(function (position) {
        var el = document.createElement('div');
        el.setAttribute('class', getClassByPosition(position));
        el.style.cssText = getWrapperBlockStyles(position);
        alertPortalElement.appendChild(el);
      });

      if (document.body) {
        document.body.appendChild(alertPortalElement);
        setAlertPortal(alertPortalElement);
      }
    }
  }, [alertPortal]);
  if (!shouldUsePortal) return children;
  var positionedElement = document.querySelector(".".concat(getClassByPosition(portalPosition)));

  if (positionedElement) {
    return /*#__PURE__*/ReactDOM.createPortal(jsx(AlertWrapper, {
      children: children
    }), positionedElement);
  }

  return null;
};

export { AlertPortal };
